// extracted by mini-css-extract-plugin
module.exports = {"btn":"Btn_btn_ULr3K typography_standard_3NYy8"};